import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import PageHeader from '../components/PageHeader';
import "../styles/common-page.css";
import formIcon from "../assets/icons/form.png";
import DownloadCard from '../components/DownloadCard';
import VillageIllustration from '../components/VillageIllustration';

const RTI = () => {
  const { i18n } = useTranslation();

  // Language-specific text content
  const content = {
    en: {
      homepage: 'Homepage',
      title: 'RTI',
      description: 'Explore our ongoing development initiatives, completed projects, and government schemes designed to enhance rural infrastructure and community welfare.',
      footerAlt: 'Footer Image'
    },
    mr: {
      homepage: 'मुख्यपृष्ठ',
      title: 'माहितीचा अधिकार',
      description: '',
      footerAlt: 'तळ चित्र'
    }
  };

  const currentContent = content[i18n.language] || content.mr;

  return (
    <>
      <div className="bg-image-section">
        <div className="flex flex-col gap-4 section-padding">
          <PageHeader
            breadcrumb={[
              <Link to="/" key="home">{currentContent.homepage}</Link>,
              currentContent.title
            ]}
            title={currentContent.title}
            description={currentContent.description}
          />

          <div>
            <div className="flex flex-col gap-6 bg-white rounded-md p-8 border-[#DDDDDD]">
              <div>
                <div className="flex items-center gap-3">
                  <img loading="lazy" src={formIcon} alt="Form Icon" className="w-10 h-10" />
                  <h2 className="text-2xl font-semibold m-0">{i18n.language === 'en' ? 'Documents' : 'दस्तऐवज'}</h2>
                </div>
                <p className="text-[#212121] text-base mb-6 mt-4">
                  {i18n.language === 'en' 
                    ? 'Here you will find all the necessary documents related to Right to Information (RTI). Also, you can visit the Maharashtra RTI portal for more information.'
                    : 'येथे तुम्हाला माहिती अधिकार (RTI) विषयी सर्व आवश्यक कागदपत्रे मिळतील. तसेच, तुम्ही महाराष्ट्र RTI पोर्टलला भेट देऊन अधिक माहिती मिळवू शकता.'}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                  <div className="">
                    <DownloadCard
                      title="माहितीचा अधिकार अधिनियम, २००५ अंतर्गत स्वयं-प्रकटीकरण माहिती"
                      titleEn="Information to be self-disclosed under RTI Act, 2005"
                      downloadLink="/documents/rti-self-disclosure.pdf"
                      buttonLabel="डाउनलोड"
                      buttonLabelEn="Download"
                    />
                  </div>
                  <div className="">
                    <DownloadCard
                      title="माहितीचा अधिकार अधिनियम, २००५ मार्गदर्शक"
                      titleEn="Guide to RTI Act, 2005"
                      downloadLink="/documents/rti-guide.pdf"
                      buttonLabel="डाउनलोड"
                      buttonLabelEn="Download"
                    />
                  </div>
                  <div className="">
                    <DownloadCard
                      title="माहितीचा अधिकार नियम, २००५"
                      titleEn="Right to Information Rules, 2005"
                      downloadLink="/documents/rti-rules.pdf"
                      buttonLabel="डाउनलोड"
                      buttonLabelEn="Download"
                    />
                  </div>
                  <div className="">
                    <DownloadCard
                      title="माहितीचा अधिकार अधिनियम, २००५"
                      titleEn="Right to Information Act, 2005"
                      downloadLink="/documents/rti-act.pdf"
                      buttonLabel="डाउनलोड"
                      buttonLabelEn="Download"
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-1">
                <DownloadCard
                  title="RTI पोर्टल लिंक"
                  titleEn="RTI Portal Link"
                  description="माहितीच्या अधिकाराबद्दल अधिक माहिती जाणून घेण्यासाठी ऑनलाईन पोर्टलला भेट द्या. तुम्ही तुमचा RTI अर्ज ऑनलाइन सबमिट करू शकता."
                  descriptionEn="Visit the online portal to learn more about Right to Information. You can submit your RTI application online."
                  downloadLink="https://rti.gov.in"
                  buttonLabel="लिंक वर जा"
                  buttonLabelEn="Go to the Link"
                  isExternalLink={true}
                />
                <DownloadCard
                  title="RTI संपर्क (PIOs / APIOs / AAs)"
                  titleEn="RTI Contacts (PIOs / APIOs / AAs)"
                  description="माहिती अधिकार कायद्याच्या अंमलबजावणीसाठी नियुक्त केलेल्या जन माहिती अधिकारी, सहाय्यक जन माहिती अधिकारी आणि अपीलीय अधिकाऱ्यांची संपर्क माहिती."
                  descriptionEn="Contact information of Public Information Officers, Assistant Public Information Officers, and Appellate Authorities appointed for implementation of the RTI Act."
                  downloadLink="/documents/rti-contacts.pdf"
                  buttonLabel="डाउनलोड"
                  buttonLabelEn="Download"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
      <VillageIllustration />
    </>
  );
};

export default RTI;